import { useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { api, apiError } from "@/lib/api";

export default function PhotoCapture({
  onUploaded, chantierId, factureId, articleId, clientId,
  type = "photo_chantier", description = "", className = "", children, testid,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  async function handleFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("type", type);
      if (chantierId) fd.append("chantier_id", chantierId);
      if (factureId) fd.append("facture_id", factureId);
      if (articleId) fd.append("article_id", articleId);
      if (clientId) fd.append("client_id", clientId);
      if (description) fd.append("description", description);
      const { data } = await api.post("/photos", fd);
      toast.success(t("photo.ok"));
      onUploaded?.(data);
    } catch (err) {
      toast.error(apiError(err, t("photo.erreur")));
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  }

  return (
    <>
      <input ref={inputRef} type="file" accept="image/*" capture="environment"
             className="hidden" onChange={handleFile}
             data-testid={testid ? `${testid}-input` : undefined} />
      <button type="button" disabled={loading} onClick={() => inputRef.current?.click()}
              className={className} data-testid={testid}>
        {loading ? <Loader2 className="animate-spin" size={20} /> : children}
      </button>
    </>
  );
}
